export enum OfferingKind {
  Endorsement = 'endorsement',
  Policy = 'policy',
  Coverage = 'coverage'
}

export enum RejectionType {
  Auto = 'auto',
  Home = 'home',
  Condo = 'condo',
  Renters = 'renters',
  Monoline = 'monoline',
  MonolineHome = 'monoline-home',
  MonolineCondo = 'monoline-condo',
  Farm = 'farm'
}

export enum RejectionLevel {
  Soft = 'soft',
  Hard = 'hard'
}

export enum ConsumerType {
  Api = 'api',
  Staff = 'staff',
  Quote = 'quote',
  Other = 'other'
}

export enum ExecutionType {
  RC1 = 'rc1',
  RC3SoftRejections = 'rc3-soft-rejections',
  RC3 = 'rc3'
}

export interface RejectionLevelHelperOptions {
  forceHardRejection?: boolean;
  consumerType?: ConsumerType | null | undefined;
  executionType?: ExecutionType | null | undefined;
  softRejectionsEnabled?: boolean | null | undefined;
  inPolicyMod?: boolean;
  isProduction?: boolean;
}
